export default "__VITE_ASSET__haRdOzMO__"